export const convertToArrayOfObjects = (rows, cols) => { // eslint-disable-line
  const newList = [];
  rows.forEach((row) => {
    const obj = {};
    row.forEach((col, j) => {
      if (cols[j]) {
        obj[cols[j].name] = col;
      }
    });
    newList.push(obj);
  });

  return newList;
};
